import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as pageName from "store/actions/pageAction";
import TreeView from "./TreeView";
import ClientInfo from "./ClientInfo";
import BulkReview from "./BulkReview";
import Accuracy from "./Accuracy";
import { getMe } from "store/actions/userAction";

export const ExploreBar = () => {
  const dispatch = useDispatch();
  const selectedActivityPage = useSelector(state => state.page.payload);

  useEffect(() => {
    dispatch(getMe());
  }, [selectedActivityPage, dispatch]);

  const renderPage = () => {
    switch (selectedActivityPage) {
      case pageName.PAGE_ACTIVITY_TREE_VIEW:
      default:
        return <TreeView />;
      case pageName.PAGE_ACTIVITY_CLIENT_INFO:
        return <ClientInfo />;
      case pageName.PAGE_ACTIVITY_BULK_REVIEW:
        return <BulkReview />;
      case pageName.PAGE_ACTIVITY_ACCURACY:
        return <Accuracy />;
    }
  };

  return <div className="explore-bar">{renderPage()}</div>;
};

export default ExploreBar;
